'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _taggedTemplateLiteral2 = require('babel-runtime/helpers/taggedTemplateLiteral');

var _taggedTemplateLiteral3 = _interopRequireDefault(_taggedTemplateLiteral2);

var _templateObject = (0, _taggedTemplateLiteral3.default)(['\n    display: flex;\n    ', '\n    ', '\n    ', '\n    ', '\n    ', '\n  '], ['\n    display: flex;\n    ', '\n    ', '\n    ', '\n    ', '\n    ', '\n  ']),
    _templateObject2 = (0, _taggedTemplateLiteral3.default)(['flex-direction: ', ';'], ['flex-direction: ', ';']),
    _templateObject3 = (0, _taggedTemplateLiteral3.default)(['justify-content: ', ';'], ['justify-content: ', ';']),
    _templateObject4 = (0, _taggedTemplateLiteral3.default)(['align-items: ', ';'], ['align-items: ', ';']),
    _templateObject5 = (0, _taggedTemplateLiteral3.default)(['flex: ', ';'], ['flex: ', ';']),
    _templateObject6 = (0, _taggedTemplateLiteral3.default)(['width: 100%;'], ['width: 100%;']);

var _styledComponents = require('styled-components');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = (0, _styledComponents.css)(_templateObject, function (props) {
  return props.flexDirection ? (0, _styledComponents.css)(_templateObject2, props.flexDirection) : '';
}, function (props) {
  return props.justifyContent ? (0, _styledComponents.css)(_templateObject3, props.justifyContent) : '';
}, function (props) {
  return props.alignItems ? (0, _styledComponents.css)(_templateObject4, props.alignItems) : '';
}, function (props) {
  return props.flex ? (0, _styledComponents.css)(_templateObject5, props.flex) : '';
}, function (props) {
  return props.block ? (0, _styledComponents.css)(_templateObject6) : '';
});